// import { ReactComponent as HomeIcon } from './iocnSVG/home.svg'
import { ReactComponent as UserIcon } from './iocnSVG/user1.svg'
import { ReactComponent as LostIcon } from './iocnSVG/lost.svg'
import { ReactComponent as LogoIcon } from './iocnSVG/logo.svg'
import { ReactComponent as PoolsIcon } from './iocnSVG/pools.svg'
import { ReactComponent as SwapIcon } from './iocnSVG/swap.svg'
import { ReactComponent as LinkIcon } from './iocnSVG/link.svg'
import { ReactComponent as ShareIcon } from './iocnSVG/share.svg'

import { ReactComponent as GroupIcon } from './iocnSVG/group5.svg'
import { ReactComponent as StairIcon } from './iocnSVG/stair3.svg'
import { ReactComponent as StakeholderIcon } from './iocnSVG/stakeholder.svg'




import { ReactComponent as SPD } from './iocnSVG/spd.svg'
import { ReactComponent as CVC } from './iocnSVG/cvc.svg'


const paths = {
    home: GroupIcon,
    stair: StairIcon,
    stakeholder: StakeholderIcon,
    user: UserIcon,

    lost: LostIcon,
    pools: PoolsIcon,
    logo: LogoIcon,
    swap: SwapIcon,
    link: LinkIcon,
    share: ShareIcon,
    spd: SPD,
    cvc: CVC
}
function MyIcon({i = 'home' ,...props}) {
  const Path = paths[i] || LostIcon
  return (
    <Path {...props}/>
  );
}

export default MyIcon
